import React from 'react';
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';

function UserGuide(props) {
    return (
        <PictureAsPdfOutlinedIcon {...props} />
    );
}

export default UserGuide;